import axios from 'axios'
import { Modal, message } from 'antd'

const SetUser = (props) => {
  const { oid, name } = props.data

  const handleOk = () => {
    axios.post('/admin/user/set_vip', { 
      user_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('设置成功！')
          props.isCancel()
          props.getUserData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="设为会员"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText='确认'>

      <p>正在取消
        <span style={{color: '#005dff'}}>《{name}》</span>
        的会员身份，是否确认提交？
      </p>
    </Modal>
  )
}

export default SetUser
